export const PARTICLES = [
    {
        size: 12,
        top: "60%",
        left: "30%",
        delay: 0.2,
        gradient: "linear-gradient(135deg, #70A2FF, #03C2EB)",
    },
    {
        size: 8,
        top: "55%",
        left: "65%",
        delay: 0.35,
        gradient: "linear-gradient(135deg, #03C2EB, #4BE2BE)",
    },
    {
        size: 6,
        top: "50%",
        left: "45%",
        delay: 0.5,
        gradient: "linear-gradient(135deg, #4BE2BE, #70A2FF)",
    },
    {
        size: 10,
        top: "65%",
        left: "55%",
        delay: 0.3,
        gradient: "linear-gradient(135deg, #70A2FF, #4BE2BE)",
    },
    {
        size: 5,
        top: "45%",
        left: "35%",
        delay: 0.45,
        gradient: "linear-gradient(135deg, #03C2EB, #70A2FF)",
    },
    {
        size: 14,
        top: "58%",
        left: "70%",
        delay: 0.25,
        gradient: "linear-gradient(135deg, #70A2FF, #03C2EB, #4BE2BE)",
    },
];
